import React, { ComponentProps, ReactElement, Suspense, useCallback } from 'react';
import { ProgressIndicator } from '@fluentui/react/lib/ProgressIndicator';
import ModalContext from '../Context/ModalContext';
import { merge } from 'lodash';
import FluentModal from './FluentModal';

const FormModal = ({
  children,
  modalOpen,
  setModalOpen,
  styles,
}: {
  children: ReactElement;
  modalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  styles: ComponentProps<typeof Modal>['styles'];
}) => {
  const closeModal = useCallback(() => {
    setModalOpen(false);
  }, [setModalOpen]);

  return modalOpen ? (
    <Suspense fallback={<ProgressIndicator />}>
      <ModalContext.Provider
        value={{
          onClose: closeModal,
        }}
      >
        <FluentModal
          isOpen={true}
          onDismiss={closeModal}
          styles={merge(
            {
              main: {
                minWidth: '600px',
                overflowY: 'unset',
              },
            },
            styles
          )}
        >
          {children}
        </FluentModal>
      </ModalContext.Provider>
    </Suspense>
  ) : null;
};

export default FormModal;
